export default __webpack_public_path__ + "static/media/login-left-icon.0ae278ed.svg";